import { doObjToFormData } from "../../helpers/helpers";
import http from "../../helpers/http";
import { toast } from "react-toastify";
import Text from "../../components/Text";
import { TOAST_SETTINGS } from "../../utils/siteSettings";

import {
  FETCH_CONTACT_US_CONTENT_SUCCESS,
  FETCH_CONTACT_US_CONTENT_FAILED,
  SAVE_CONTACT_MESSAGE,
  SAVE_CONTACT_MESSAGE_SUCCESS,
  SAVE_CONTACT_MESSAGE_SUCCESS_ERROR,
  SAVE_CONTACT_MESSAGE_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("contact-us")
    .then(({ data }) => {
      dispatch({
        type: FETCH_CONTACT_US_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_CONTACT_US_CONTENT_FAILED,
        payload: error
      });
    });
};

export const saveContactMessage = (formData) => (dispatch) => {
  dispatch({
    type: SAVE_CONTACT_MESSAGE,
    payload: null
  });
  http
    .post("save-contact-message", doObjToFormData(formData))
    .then(({ data }) => {
      if (data.validationErrors) {
        toast.error(
          <Text string={data.validationErrors} parse={true} />,
          TOAST_SETTINGS
        );
        dispatch({
          type: SAVE_CONTACT_MESSAGE_SUCCESS_ERROR,
          payload: data
        });
      } else {
        toast.success("Message sent successfully.", TOAST_SETTINGS);
        dispatch({
          type: SAVE_CONTACT_MESSAGE_SUCCESS,
          payload: data
        });
      }

    })
    .catch((error) => {
      dispatch({
        type: SAVE_CONTACT_MESSAGE_FAILED,
        payload: error
      });
    });
};
